/**
 * Shared page header for every admin page.
 *
 * Lays out title + optional subtitle on the left and an action slot on the
 * right (for "+ New group" style primary buttons or toolbar clusters).
 *
 * Keeps typography and spacing consistent so pages don't drift visually as
 * they grow.
 */

import React from 'react';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';

export interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
  return (
    <Column spacing="small" spacingInset="none">
      <Row alignmentHorizontal="justify" alignmentVertical="top" wrap="down" spacing="medium">
        <Column spacing="xsmall" minWidth={0}>
          <Heading level={2} type="h300">
            {title}
          </Heading>
          {subtitle && (
            <Text type="b200" color="secondary">
              {subtitle}
            </Text>
          )}
        </Column>
        {actions && (
          <Row spacing="small" alignmentVertical="center" wrap="down">
            {actions}
          </Row>
        )}
      </Row>
    </Column>
  );
};
